import React from 'react';
import { Container, Row, Col, Card, Button, ListGroup } from 'react-bootstrap';
import { Link } from 'react-router-dom';

const Dashboard = () => {
  // Mock data for prototype
  const user = {
    name: 'John Doe',
    email: 'john.doe@example.com',
    qrCodes: [
      { id: 1, name: 'Laptop', message: 'This laptop belongs to John Doe. Please contact me at john.doe@example.com if found.' },
      { id: 2, name: 'Phone', message: 'If found, please call my emergency contact at +1234567890.' },
      { id: 3, name: 'Wallet', message: 'This wallet belongs to John Doe. Reward offered for return.' }
    ]
  };

  return (
    <Container>
      <h1 className="mb-4">Dashboard</h1>
      
      <Row>
        <Col md={4}>
          <Card className="mb-4">
            <Card.Body>
              <Card.Title>Profile</Card.Title>
              <Card.Text>
                <strong>Name:</strong> {user.name}<br />
                <strong>Email:</strong> {user.email}
              </Card.Text>
              <Button variant="outline-primary" size="sm">Edit Profile</Button>
            </Card.Body>
          </Card>
          
          <Card>
            <Card.Body>
              <Card.Title>Quick Actions</Card.Title>
              <div className="d-grid gap-2">
                <Button as={Link} to="/generate-qr" variant="primary">
                  Generate New QR Code
                </Button>
                <Button variant="outline-secondary">
                  View QR Code Statistics
                </Button>
              </div>
            </Card.Body>
          </Card>
        </Col>
        
        <Col md={8}>
          <Card>
            <Card.Body>
              <Card.Title>Your QR Codes</Card.Title>
              {user.qrCodes.length === 0 ? (
                <p>You haven't created any QR codes yet.</p>
              ) : (
                <ListGroup variant="flush">
                  {user.qrCodes.map(qrCode => (
                    <ListGroup.Item key={qrCode.id} className="d-flex justify-content-between align-items-start">
                      <div className="ms-2 me-auto">
                        <div className="fw-bold">{qrCode.name}</div>
                        <small className="text-muted">{qrCode.message.substring(0, 50)}...</small>
                      </div>
                      <div>
                        <Button variant="outline-primary" size="sm" className="me-2">View</Button>
                        <Button variant="outline-danger" size="sm">Delete</Button>
                      </div>
                    </ListGroup.Item>
                  ))}
                </ListGroup>
              )}
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default Dashboard;